'use client';

import React from 'react';

import CollectionsContext from './CollectionsContext';

const CollectionsProvider = ({ value = null, children }) => (
  <CollectionsContext.Provider value={value}>
    {children}
  </CollectionsContext.Provider>
);

export default CollectionsProvider;
